// extracted by mini-css-extract-plugin
export default {"item":"analytics_item__TJtse"};